import { Link2, AlertTriangle } from 'lucide-react';

interface Props {
  gutachtenAktenNummer: string;
  isTotalschaden: boolean;
  onVerknuepfungLoesen: () => void;
  isLoading: boolean;
}

export default function GutachtenUebernahmeBanner({
  gutachtenAktenNummer,
  isTotalschaden,
  onVerknuepfungLoesen,
  isLoading,
}: Props) {
  return (
    <div
      data-testid="gutachten-uebernahme-banner"
      className="mx-5 mt-3 rounded-xl border px-4 py-3 space-y-2"
      style={{ borderColor: '#E85D04', backgroundColor: 'rgba(232,93,4,0.06)' }}
    >
      <div className="flex items-start gap-2.5">
        <Link2
          className="w-4 h-4 mt-0.5 flex-shrink-0"
          style={{ color: '#E85D04' }}
          aria-hidden
        />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-800">
            Aus Gutachten{' '}
            <span className="font-mono font-semibold" data-testid="gutachten-akten-nummer">
              {gutachtenAktenNummer}
            </span>{' '}
            übernommen — Anspruchsteller, Versicherung, Schadennummer und Fahrzeugklasse vorbefüllt.
            Bitte Mietfahrzeug-Daten und Mietzeitraum ergänzen.
          </p>
          {isTotalschaden && (
            <p
              className="flex items-center gap-1.5 text-sm font-semibold mt-1.5"
              style={{ color: '#E85D04' }}
              data-testid="totalschaden-hinweis"
            >
              <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0" aria-hidden />
              Totalschaden — maximale Mietdauer 14 Tage.
            </p>
          )}
        </div>
        <button
          type="button"
          data-testid="verknuepfung-loesen-button"
          onClick={onVerknuepfungLoesen}
          disabled={isLoading}
          className="flex-shrink-0 text-xs font-semibold px-2.5 py-1 rounded-md border transition-colors disabled:opacity-50"
          style={{ borderColor: '#E85D04', color: '#E85D04' }}
        >
          {isLoading ? '…' : 'Verknüpfung lösen'}
        </button>
      </div>
    </div>
  );
}
